'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toJS = toJS;
exports.toJSON = toJSON;

var _ramda = require('ramda');

var _immutable = require('../../immutable');

var _is_model = require('./is_model');

var _parent_pointer = require('./parent_pointer');

function attrToJS(attr) {
  if ((0, _is_model.isModel)(attr)) {
    return attr.toJS();
  } else if ((0, _immutable.isImmutableList)(attr)) {
    return attr.map(attrToJS).toArray();
  } else if ((0, _immutable.isImmutableIterable)(attr)) {
    return attr.toJS();
  } else if ((0, _ramda.is)(Array, attr) || (0, _ramda.is)(Object, attr)) {
    return (0, _ramda.map)(attrToJS, attr);
  } else {
    return attr;
  }
}

function attrToJSON(attr) {
  if ((0, _is_model.isModel)(attr)) {
    return attr.toJSON();
  } else if ((0, _immutable.isImmutableList)(attr)) {
    return attr.map(attrToJSON).toArray();
  } else if ((0, _immutable.isImmutableIterable)(attr)) {
    return attr.toJSON();
  } else if ((0, _ramda.is)(Array, attr) || (0, _ramda.is)(Object, attr)) {
    return (0, _ramda.map)(attrToJSON, attr);
  } else {
    return attr;
  }
}

function toJS(model) {
  return (0, _ramda.map)(attrToJS, model.props());
}

// for JSON.stringify
function toJSON(model) {
  return (0, _ramda.merge)((0, _ramda.map)(attrToJSON, model.props()), {
    path: (0, _parent_pointer.getPathFromRoot)(model)
  });
}